export default __webpack_public_path__ + "static/media/BANNER2.47701680.jpg";